export const sectorsData = [
  {
    slug: "oil-gas",
    title: "Oil & Gas",
    shortDesc: "Specialized staffing for upstream, midstream, and downstream operations.",
    image: "/img_to_use/oil and gas.jpg",
    banner: "/img_to_use/oil and gas.jpg",
    fullDesc: `
      <p>We provide expert recruitment for the oil & gas sector, supporting both onshore and offshore projects. Our network includes engineers, project managers, safety specialists, and technical staff with proven experience in exploration, drilling, production, and refining.</p>
      <p>We understand the compliance, safety, and technical demands of the industry, and deliver talent that keeps your operations running smoothly and safely—whether you're ramping up for a new project or maintaining critical infrastructure.</p>
      <ul>
        <li><strong>Key roles we fill:</strong></li>
        <li>Drilling Engineers & Supervisors</li>
        <li>Pipeline Engineers</li>
        <li>Health, Safety & Environment (HSE) Managers</li>
        <li>Production Technicians</li>
        <li>Project Managers</li>
        <li>QA/QC Engineers</li>
      </ul>
    `,
    bullets: [
      "Drilling Engineers & Supervisors",
      "Pipeline Engineers",
      "HSE Managers",
      "Production Technicians",
      "Project Managers",
      "QA/QC Engineers"
    ]
  },
  {
    slug: "fmcg",
    title: "FMCG",
    shortDesc: "Recruitment for fast-moving consumer goods: sales, supply chain, and more.",
    image: "/img_to_use/FMCG.jpg",
    banner: "/img_to_use/FMCG.jpg",
    fullDesc: `
      <p>Our FMCG recruitment solutions cover the entire value chain—from manufacturing and warehousing to retail and brand management. We understand the pace and complexity of the sector, and deliver candidates who thrive in high-volume, customer-driven environments.</p>
      <p>We help you build teams that drive growth, innovation, and operational excellence in a competitive market.</p>
      <ul>
        <li><strong>Key roles we fill:</strong></li>
        <li>Sales & Marketing Managers</li>
        <li>Brand Managers</li>
        <li>Supply Chain & Logistics Coordinators</li>
        <li>Warehouse & Retail Staff</li>
        <li>Merchandisers</li>
        <li>Account Managers</li>
      </ul>
    `,
    bullets: [
      "Sales & Marketing Managers",
      "Brand Managers",
      "Supply Chain & Logistics Coordinators",
      "Warehouse & Retail Staff",
      "Merchandisers",
      "Account Managers"
    ]
  },
  {
    slug: "infrastructure",
    title: "Infrastructure",
    shortDesc: "Staffing for large-scale infrastructure and civil engineering projects.",
    image: "/img_to_use/Infrastructure.jpg",
    banner: "/img_to_use/Infrastructure.jpg",
    fullDesc: `
      <p>We support infrastructure projects with skilled professionals in construction, project management, and technical operations. Our candidates have experience in roads, bridges, ports, airports, and urban development.</p>
      <p>We help you deliver projects on time and on budget, with a focus on safety, quality, and compliance.</p>
      <ul>
        <li><strong>Key roles we fill:</strong></li>
        <li>Civil Engineers</li>
        <li>Project Managers</li>
        <li>Site Supervisors</li>
        <li>Surveyors</li>
        <li>Construction Managers</li>
        <li>Health & Safety Officers</li>
      </ul>
    `,
    bullets: [
      "Civil Engineers",
      "Project Managers",
      "Site Supervisors",
      "Surveyors",
      "Construction Managers",
      "Health & Safety Officers"
    ]
  },
  {
    slug: "engineering",
    title: "Engineering Procurement & Construction",
    shortDesc: "End-to-end staffing for EPC projects: design, procurement, and build.",
    image: "/img_to_use/Engineering Procurement & Construction.jpg",
    banner: "/img_to_use/Engineering Procurement & Construction.jpg",
    fullDesc: `
      <p>We provide talent for every phase of EPC projects, from initial design and procurement to construction and commissioning. Our network includes engineers, procurement specialists, project controllers, and site managers with experience in complex, multidisciplinary projects.</p>
      <p>We help you assemble teams that deliver quality, safety, and efficiency at every stage.</p>
      <ul>
        <li><strong>Key roles we fill:</strong></li>
        <li>Design Engineers</li>
        <li>Procurement Managers</li>
        <li>Project Controllers</li>
        <li>Construction Managers</li>
        <li>Commissioning Engineers</li>
        <li>Quality Assurance Specialists</li>
      </ul>
    `,
    bullets: [
      "Design Engineers",
      "Procurement Managers",
      "Project Controllers",
      "Construction Managers",
      "Commissioning Engineers",
      "Quality Assurance Specialists"
    ]
  }
];
